export default "__VITE_ASSET__B9S0LXN4__"